// removed by extract-text-webpack-plugin
module.exports = {"content":"_395fqNPMJ16pqJB6FYCnS_","category":"BOgEpef_fO0W5DSGnoBIT","category_child":"_1lv14y7JDzYRcviTYFPq3O"};


//////////////////
// WEBPACK FOOTER
// ./src/Techs.css
// module id = 37
// module chunks = 0